// Mock data for Gulmohar Global Travels

export const vehicles = [
  {
    id: 1,
    name: "Maruti Dzire",
    image: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/3k9ddgaw_dzire.jpg",
    seating: "4 Seater",
    ratePerKm: 12,
    features: ["AC", "Clean & Sanitized", "Professional Driver"]
  },
  {
    id: 2,
    name: "Ertiga",
    image: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/6t6ai8gy_Ertiga.jpg",
    seating: "6-7 Seater",
    ratePerKm: 14,
    features: ["AC", "Spacious", "Family Friendly"]
  },
  {
    id: 3,
    name: "Innova Crysta",
    image: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/fc6eqk94_Innova.jpg",
    seating: "7 Seater",
    ratePerKm: 18,
    features: ["AC", "Premium Comfort", "Luxury Interior"]
  },
  {
    id: 4,
    name: "Tempo Traveller (17 Seater)",
    image: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/qhrt7erl_traveller.jpg",
    seating: "17 Seater",
    ratePerKm: 25,
    features: ["AC", "Group Travel", "Comfortable Seating"]
  },
  {
    id: 5,
    name: "Tempo Traveller (20 Seater)",
    image: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/qhrt7erl_traveller.jpg",
    seating: "20 Seater",
    ratePerKm: 28,
    features: ["AC", "Large Groups", "Extra Space"]
  },
  {
    id: 6,
    name: "Tempo Traveller (26 Seater)",
    image: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/1uj2t42b_urbania.jpg",
    seating: "26 Seater",
    ratePerKm: 35,
    features: ["AC", "Corporate Events", "Premium Comfort"]
  },
  {
    id: 7,
    name: "45 Seater Packglass Bus",
    image: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/v7iubnmo_45%20seater%20bus.jpeg",
    seating: "45 Seater",
    ratePerKm: 70,
    features: ["AC", "Large Events", "Professional Service"]
  }
];

export const touristPlaces = [
  {
    id: 1,
    name: "Varanasi",
    image: "https://images.unsplash.com/photo-1661771402987-9dc9db2cbb63",
    description: "Experience the spiritual heart of India with the mesmerizing Ganga Aarti at the ghats and visit the ancient Kashi Vishwanath Temple. Witness centuries of tradition and devotion.",
    highlights: ["Kashi Vishwanath Temple", "Ganga Aarti", "Ancient Ghats"]
  },
  {
    id: 2,
    name: "Ayodhya",
    image: "https://images.unsplash.com/photo-1652059468424-249066e3a98f",
    description: "Visit the newly built Ram Mandir and experience the divine atmosphere of Lord Ram's birthplace. Take a serene walk along the Saryu River and explore ancient temples.",
    highlights: ["Ram Mandir", "Saryu River", "Hanuman Garhi"]
  },
  {
    id: 3,
    name: "Prayagraj",
    image: "https://images.unsplash.com/photo-1659202285338-af87824ce33b",
    description: "Witness the sacred Triveni Sangam where three holy rivers meet. Home to the famous Kumbh Mela, this city holds immense spiritual significance for millions of devotees.",
    highlights: ["Triveni Sangam", "Kumbh Mela", "Allahabad Fort"]
  },
  {
    id: 4,
    name: "Mathura & Vrindavan",
    image: "https://images.unsplash.com/photo-1697528556914-5b2e767bbb5f",
    description: "Explore the birthplace of Lord Krishna in Mathura and experience the divine love in Vrindavan's beautiful temples. Participate in the enchanting evening aarti ceremonies.",
    highlights: ["Krishna Janmabhoomi", "Banke Bihari Temple", "ISKCON Temple"]
  },
  {
    id: 5,
    name: "Agra",
    image: "https://images.unsplash.com/photo-1564507592333-c60657eea523",
    description: "Visit the iconic Taj Mahal, one of the Seven Wonders of the World. Explore the magnificent Agra Fort and experience the rich Mughal heritage of this historic city.",
    highlights: ["Taj Mahal", "Agra Fort", "Fatehpur Sikri"]
  },
  {
    id: 6,
    name: "Lucknow",
    image: "https://images.unsplash.com/photo-1601752874509-0e350467dc7b",
    description: "Discover the city of Nawabs with its architectural marvels like Bara Imambara. Savor the famous Lucknowi cuisine and experience the rich cultural heritage and hospitality.",
    highlights: ["Bara Imambara", "Chota Imambara", "Rumi Darwaza"]
  }
];

export const companyInfo = {
  name: "Gulmohar Global Travels",
  tagline: "Best Taxi & Cab Service in Varanasi",
  phone: ["7905165043", "9919689525"],
  email: "gulmoharglobaltravels@gmail.com",
  address: "G-24, PCF Plaza, Nadesar, Near Taj Hotel, Varanasi",
  logo: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/e8wfijlc_logo.jpeg",
  qrCode: "https://customer-assets.emergentagent.com/job_gulmohar-travel/artifacts/tqdpwx9i_QR.JPG",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.3976890897253!2d83.0084684!3d25.3178384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e2db76febf21b%3A0x68131710b29fe86b!2sNadesar%2C%20Varanasi%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1234567890"
};

export const services = [
  "Local Taxi Service",
  "Outstation Cab Booking",
  "Airport Pickup & Drop",
  "Tempo Traveller Rental",
  "Bus Booking for Events",
  "Corporate Travel Solutions",
  "Religious Tour Packages",
  "24×7 Customer Support"
];
